export default __webpack_public_path__ + "static/media/ShortClass.8142c024.png";